import * as React from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';

export const TableLoader = () => {
    return (
        <Box sx={{ display: 'flex' }}>
            <CircularProgress color='primary'
                size={30}
                disableShrink
            />
        </Box>
    );
}

// import React from 'react';
// import Lottie from 'lottie-react';
// import animationData from '../../assets/animations/TableRoundedLoader.json';
// import { Typography } from '@mui/material';

// export const TableLoader = () => {

//     return (
//         <div style={{ display: "flex", flexDirection: 'column', alignItems: 'center' }}>
//             <Lottie
//                 animationData={animationData}
//                 loop={true}
//                 style={{ height: '80px' }}
//             />
//             <Typography sx={{
//                 fontFamily: "'Montserrat', sans-serif",
//                 fontWeight: 600,
//                 letterSpacing: '1px',
//                 color: 'linear-gradient(90deg, #ff8a00, #e52e71)',
//                 textTransform: 'uppercase',
//                 textShadow: '1px 1px 2px rgba(0,0,0,0.1)',
//                 animation: 'pulse 1.5s infinite',
//                 '@keyframes pulse': {
//                     '0%': { opacity: 0.8 },
//                     '50%': { opacity: 0.4 },
//                     '100%': { opacity: 0.8 }
//                 }
//             }}>Loading...</Typography>
//         </div>
//     );
// };
